import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-35d9c027"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "top-swiper-box"
};
const _hoisted_2 = {
  key: 0,
  class: "top-swiper-info"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  key: 2,
  class: "top-swiper-info-nums"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon"
}, "/", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CompVideo = _resolveComponent("CompVideo");
  const _component_van_swipe_item = _resolveComponent("van-swipe-item");
  const _component_van_swipe = _resolveComponent("van-swipe");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.if_video_play ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_CompVideo, {
    class: "video",
    video_url: $data.videoUrl,
    onShowImg: $options.showImg
  }, null, 8, ["video_url", "onShowImg"])])) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "top-swiper-info",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.playVideo && $options.playVideo(...args))
  }, [$props.product_info.wb_logos && $props.product_info.wb_logos.length > 0 ? (_openBlock(), _createBlock(_component_van_swipe, {
    key: 0,
    "show-indicators": false,
    onChange: $options.swiperChange,
    loop: false
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.product_info.wb_logos, image => {
      return _openBlock(), _createBlock(_component_van_swipe_item, {
        key: image
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          src: _ctx.$imgUrlFilter(image ? image : require('@assets/images/placeholder/default_1x1@2x.png'), $options.imgWidth)
        }, null, 8, _hoisted_3)]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }, 8, ["onChange"])) : (_openBlock(), _createElementBlock("img", {
    key: 1,
    src: _ctx.$imgUrlFilter($props.product_info.logo_1x1 ? $props.product_info.logo_1x1 : require('@assets/images/placeholder/default_1x1@2x.png'), $options.imgWidth)
  }, null, 8, _hoisted_4)), $props.product_info.wb_logos && $props.product_info.wb_logos.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString($data.currentIndex), 1), _hoisted_6, _createElementVNode("span", null, _toDisplayString($props.product_info.wb_logos && $props.product_info.wb_logos.length > 0 ? $props.product_info.wb_logos.length : 1), 1)])) : _createCommentVNode("", true), $props.product_info.video_info && $data.currentIndex == 1 ? (_openBlock(), _createElementBlock("div", {
    key: 3,
    class: "play-btn",
    style: _normalizeStyle(`background-image:url(${_ctx.$imgUrlFilter('https://p6.moimg.net/md/icon/video_play@2x.png', 112, 112)});`)
  }, null, 4)) : _createCommentVNode("", true)]))]);
}